import React, {
  useEffect, useMemo, useState,
} from 'react';

import { Container } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import styles from './View.Style';

import Loading from 'components_newui/Loading';

import TemplateHeader from './components/TemplateHeader';
import ScorecardCard from './components/ScorecardCard';
import EmptyState from './components/EmptyState';

const ScorecardListTemplates = ({
  classes,
  myEmail,
  getCloneScorecardTemplateFn,
  getScorecardTemplatelistFn,
  listScorecardTemplateLoading,
  listScorecardTemplate = [],
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    getScorecardTemplatelistFn?.();
  }, [getScorecardTemplatelistFn]);

  const filteredTemplates = useMemo(() => {
    const searchValue = searchTerm.trim().toLowerCase();

    if (!searchValue) {
      return listScorecardTemplate;
    }

    return listScorecardTemplate.filter(item => {
      const templateName =
        item?.templateName?.toLowerCase() || '';

      const createdBy =
        item?.createdBy?.toLowerCase() || '';

      return (
        templateName.includes(searchValue) ||
        createdBy.includes(searchValue)
      );
    });
  }, [listScorecardTemplate, searchTerm]);

  if (listScorecardTemplateLoading) {
    return <Loading />;
  }

  return (
    <Container maxWidth={false}>
      <div className={classes.scorecardwrp}>
        <TemplateHeader
          classes={classes}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          totalCount={filteredTemplates.length}
        />

        <div className={classes.templateCols}>
          {filteredTemplates.length ? (
            filteredTemplates.map(item => (
              <ScorecardCard
                key={item.id}
                classes={classes}
                data={item}
                myEmail={myEmail}
                getCloneScorecardTemplateFn={
                  getCloneScorecardTemplateFn
                }
              />
            ))
          ) : (
            <EmptyState classes={classes} />
          )}
        </div>
      </div>
    </Container>
  );
};

export default withStyles(styles)(ScorecardListTemplates);